import {CONFIG} from '../../appConfig';

const COUPON = 'coupon/';

export default {
  /**
   * @desc Request coupon details by coupon code
   * @param {Object} data {params, payload}
   * @returns {Object}
   * @memberof services.gma.coupon
   * @example
   * const data = {
   *  payload: {
   *    coupons, // *(Array)* i.e. ['CURREN323']
   *  }
   * }
   * services.gma.coupon.details(data);
   * // The will not store anything to state, use actions.content.getCouponDetails(['CURREN323']) to store details in state.gmi.gma.coupon.details[coupon.code], for each coupon code in the data array
   */
  details(data = {}) {
    const {params = {}, payload = {}} = data;
    return {
      method: 'POST',
      origin: CONFIG.GMA_ORIGIN_URL,
      endpoint: `${COUPON}details`,
      params,
      data: payload
    };
  }
};
